import chevronDown from 'assets/icons/chevron-down.svg'
import styled from 'styled-components'

export const Section = styled.div`
  background: #ffffff;
  border-radius: 16px;
  padding: 20px 24px;
  border: 0.91px solid #e2e2e2;
  max-width: 640px;
`

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;

  .account-holder {
    display: flex;
    align-items: center;
    gap: 12px;
    min-width: 0;
  }

  .account-holder-details {
    display: flex;
    flex-direction: column;
    gap: 2px;
    min-width: 0;
  }

  .doctor-name {
    font-size: 1.6rem !important;
    font-weight: 700;
    color: #2c2c2c;
  }

  .account-subtitle {
    font-size: 1.2rem !important;
    font-weight: 400;
    color: #4d4d4d;
  }
`

export const Avatar = styled.div<{ hasPhoto: boolean }>`
  width: 40px;
  height: 40px;
  border-radius: 40px;
  flex-shrink: 0;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${({ hasPhoto }) => (hasPhoto ? 'transparent' : '#ff5100')};
  color: #efefef;
  font-size: 1.4rem;
  font-weight: 700;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`

export const EditButton = styled.button`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 14px;
  border-radius: 8px;
  border: 1px solid #ff5100;
  background: transparent;
  color: #ff5100;
  font-size: 1.3rem !important;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;

  svg {
    width: 16px;
    height: 16px;
  }

  &:hover {
    background: #fff1e0;
  }
`

export const Divider = styled.hr`
  border: none;
  border-top: 1px solid #e2e2e2;
  margin: 20px 0;
`

export const SectionTitle = styled.h3`
  font-size: 1.3rem !important;
  font-weight: 600;
  color: #4d4d4d;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  margin: 0 0 4px;
`

export const FieldsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px 24px;

  @media (max-width: 480px) {
    grid-template-columns: 1fr;
  }
`

export const EmptyState = styled.div`
  padding: 24px 0;
  text-align: center;
  font-size: 1.4rem !important;
  color: ${({ theme }) => theme.colors.gray80};
`

export const FormGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px 24px;
  margin-top: 20px;

  @media (max-width: 480px) {
    grid-template-columns: 1fr;
  }
`

export const FormField = styled.div<{ fullWidth?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 0;
  ${({ fullWidth }) => fullWidth && 'grid-column: 1 / -1;'}

  label {
    font-size: 1.3rem !important;
    font-weight: 600;
    color: #2c2c2c;
  }

  input,
  select {
    height: 44px;
    padding: 0 14px;
    border-radius: 8px;
    border: 1px solid #e2e2e2;
    font-size: 1.4rem !important;
    color: #2c2c2c;
    background-color: #ffffff;
    outline: none;
    width: 100%;

    &:focus {
      border-color: #ff5100;
    }
  }

  select {
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    padding-right: 36px;
    cursor: pointer;
    background-image: url('${chevronDown}');
    background-repeat: no-repeat;
    background-position: right 14px center;
    background-size: 12px;

    &::-ms-expand {
      display: none;
    }
  }
`

export const RequiredMark = styled.span`
  color: #e02424;
  margin-left: 2px;
`

export const FieldError = styled.span`
  font-size: 1.2rem !important;
  font-weight: 500;
  color: #e02424;
`

export const FormActions = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 24px;
`

export const CancelButton = styled.button`
  padding: 10px 20px;
  border-radius: 8px;
  border: none;
  background: #e2e2e2;
  color: #2c2c2c;
  font-size: 1.4rem !important;
  font-weight: 600;
  cursor: pointer;

  &:hover {
    background: #d5d5d5;
  }
`

export const SaveButton = styled.button`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 10px 20px;
  border-radius: 8px;
  border: none;
  background: #ff5100;
  color: #f7f7f7;
  font-size: 1.4rem !important;
  font-weight: 600;
  cursor: pointer;

  svg {
    width: 14px;
    height: 14px;
    color: #f7f7f7;
  }

  &:hover {
    background: #e64800;
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`

export const Field = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;

  .field-label {
    font-size: 1.1rem !important;
    font-weight: 600;
    color: #8c8c8c;
    text-transform: uppercase;
    letter-spacing: 0.3px;
  }

  .field-value {
    font-size: 1.4rem !important;
    font-weight: 600;
    color: #2c2c2c;
    word-break: break-word;
  }
`
